export const SAVE_SCENES_FOR_ANOTHER_SCENE_CONDITION = '@@anotherScenesList/saveScenesForAnotherSceneCondition'
export const SYNC_SCENES_FOR_ANOTHER_SCENE_CONDITION = '@@anotherScenesList/syncScenesForAnotherSceneCondition'

export const RESET_ANOTHER_SCENES_LIST = '@@anotherScenesList/reset'
